interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  className?: string;
}

export const SectionHeader = ({ title, subtitle, className = "" }: SectionHeaderProps) => (
  <div className={`mb-6 ${className}`}>
    <h2 className="text-white text-xl font-semibold mb-2">{title}</h2>
    {subtitle && <p className="text-slate-400 text-sm">{subtitle}</p>}
  </div>
);